<template>
  <div class="modal fade" id="preview3dModal" tabindex="-1">
    <div class="modal-dialog modal-xl">
      <div class="modal-content text-center">
        <div v-if="showModal" class="modal-body modal-body-gallery">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
          <div class="row">
            <div class="col-12">
              <ModelViewer3d
                v-if="localModelSrc"
                :src="localModelSrc"
                :width="950"
                :height="626"
              />
              <iframe
                v-else-if="sketchupSrc"
                :src="sketchupSrc"
                frameborder="0"
                scrolling="no"
                marginheight="0"
                marginwidth="0"
                width="950"
                height="626"
                allowfullscreen
              ></iframe>
              <div v-else class="p-5 text-muted">
                3D-Modell fehlt. Bitte im Admin ein <code>.glb</code>-Modell hochladen
                oder einen gültigen 3D-Link hinterlegen.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from '@vue/reactivity'
import { useStore } from 'vuex'
import ModelViewer3d from '~/components/ModelViewer3d.vue'

function encodeModelUrl (url) {
  try {
    const parsed = new URL(url, window.location.origin)
    parsed.pathname = parsed.pathname
      .split('/')
      .map((part) => encodeURIComponent(decodeURIComponent(part)))
      .join('/')
    return parsed.toString()
  } catch (e) {
    return String(url).replace(/ /g, '%20')
  }
}

function apiBaseUrl () {
  const raw = String(process.env.VUE_APP_API_URL || '').trim()
  if (!raw) {
    return ''
  }
  return raw.replace(/\/?$/, '/')
}

function toProxiedModelUrl (url) {
  if (!url) {
    return url
  }
  const value = String(url)
  const isRemoteStorage = /cdn\.loewe-zaun\.de|digitaloceanspaces\.com/i.test(value)
  if (!isRemoteStorage) {
    return value
  }
  const match = value.match(/\/models\/([^/?#]+)/i)
  if (!match) {
    return value
  }
  const base = apiBaseUrl()
  if (!base) {
    return value
  }
  return base + 'models/' + encodeURIComponent(match[1])
}

function resolveLocalModelSrc (link) {
  if (!link) {
    return null
  }
  let value = String(link).trim().replace(/ /g, '%20')
  if (!value) {
    return null
  }

  if (/\.skp($|\?)/i.test(value)) {
    return toProxiedModelUrl(encodeModelUrl(value.replace(/\.skp(?=$|\?)/i, '.glb')))
  }

  if (/\.dae($|\?)/i.test(value) || /\.glb($|\?)/i.test(value) || /\.gltf($|\?)/i.test(value)) {
    if (!/^https?:\/\//i.test(value) && !value.startsWith('/')) {
      value = '/' + value.replace(/^\.?\//, '')
    }
    return toProxiedModelUrl(encodeModelUrl(value))
  }

  if (value.startsWith('/models/') || value.startsWith('models/')) {
    const normalized = value.startsWith('/') ? value : '/' + value
    if (!/\.[a-z0-9]+($|\?)/i.test(normalized)) {
      return toProxiedModelUrl(encodeModelUrl(normalized.replace(/\/?$/, '/') + 'model.glb'))
    }
    return toProxiedModelUrl(encodeModelUrl(normalized))
  }

  return null
}

function extractWarehouseModelId (link) {
  if (!link) {
    return null
  }
  const value = String(link)
  const patterns = [
    /WarehouseModelId=([0-9a-f-]{36})/i,
    /3dwarehouse\.sketchup\.com\/(?:embed|model)\/([0-9a-f-]{36})/i,
    /app\.sketchup\.com\/viewer\/3dw\?[^#]*WarehouseModelId=([0-9a-f-]{36})/i
  ]
  for (let i = 0; i < patterns.length; i++) {
    const match = value.match(patterns[i])
    if (match) {
      return match[1]
    }
  }
  return null
}

function resolveSketchupSrc (link) {
  const warehouseId = extractWarehouseModelId(link)
  if (warehouseId) {
    return 'https://app.sketchup.com/viewer/3dw?WarehouseModelId=' + warehouseId
  }
  return null
}

export default {
  components: {
    ModelViewer3d
  },
  setup () {
    const store = useStore()
    const showModal = computed(() => {
      return store.getters['configurator/previewThreedModal']
    })
    const rawLink = computed(() => {
      return store.getters['configurator/threed']?.link || ''
    })
    const localModelSrc = computed(() => {
      return resolveLocalModelSrc(rawLink.value)
    })
    const sketchupSrc = computed(() => {
      if (localModelSrc.value) {
        return null
      }
      return resolveSketchupSrc(rawLink.value)
    })
    function closeModal () {
      store.commit('configurator/SET_PREVIEW_THREED_MODAL_SHOW', false)
    }
    return {
      showModal,
      closeModal,
      localModelSrc,
      sketchupSrc
    }
  }
}
</script>
